// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MimaIsSafe_safe__2IHcd {
  max-width: 100vw;
  background-color: var(--color-dark);
  padding: 7.5rem 12rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media only screen and (max-width: 62.5em) {
  .MimaIsSafe_safe__2IHcd {
    flex-direction: column;
    gap: 3rem;
  }
}
.MimaIsSafe_safe__img__Gv\\+cj {
  height: 25rem;
  margin-right: 10rem;
}
@media only screen and (max-width: 62.5em) {
  .MimaIsSafe_safe__img__Gv\\+cj {
    margin-right: 0;
  }
}
.MimaIsSafe_safe__text__GkyBs {
  display: flex;
  flex-direction: column;
  color: var(--color-white);
  text-align: center;
}
.MimaIsSafe_safe__text_title__0OHQU {
  font-weight: 700;
  font-size: var(--default-font-h2);
  line-height: 5rem;
  margin-bottom: 1rem;
}
@media only screen and (max-width: 62.5em) {
  .MimaIsSafe_safe__text_title__0OHQU {
    font-size: var(--default-font-h3);
  }
  .MimaIsSafe_safe__text_body__3oU8k {
    font-size: var(--default-font-small);
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/LandingPage/MimaIsSafe.module.scss"],"names":[],"mappings":"AACA;EACC,gBAAA;EACA,mCAAA;EACA,qBAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;AADD;AAGC;EATD;IAUE,sBAAA;IACA,SAAA;EAAA;AACF;AAEC;EACC,aAAA;EACA,mBAAA;AAAF;AACE;EAHD;IAIE,eAAA;EAED;AACF;AACC;EACC,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;AACF;AACE;EACC,gBAAA;EACA,iCAAA;EACA,iBAAA;EACA,mBAAA;AACH;AAAG;EALD;IAME,iCAAA;EAGF;EACA;IAEE,oCAAA;EAEF;AAJF","sourcesContent":["@import '../variables/breakpoints';\n.safe {\n\tmax-width: 100vw;\n\tbackground-color: var(--color-dark);\n\tpadding: 7.5rem 12rem;\n\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\n\t@media only screen and (max-width: $bp-large) {\n\t\tflex-direction: column;\n\t\tgap: 3rem;\n\t}\n\n\t&__img {\n\t\theight: 25rem;\n\t\tmargin-right: 10rem;\n\t\t@media only screen and (max-width: $bp-large) {\n\t\t\tmargin-right: 0;\n\t\t}\n\t}\n\n\t&__text {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tcolor: var(--color-white);\n\t\ttext-align: center;\n\n\t\t&_title {\n\t\t\tfont-weight: 700;\n\t\t\tfont-size: var(--default-font-h2);\n\t\t\tline-height: 5rem;\n\t\t\tmargin-bottom: 1rem;\n\t\t\t@media only screen and (max-width: $bp-large) {\n\t\t\t\tfont-size: var(--default-font-h3);\n\t\t\t}\n\t\t}\n\n\t\t&_body {\n\t\t\t@media only screen and (max-width: $bp-large) {\n\t\t\t\tfont-size: var(--default-font-small);\n\t\t\t}\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"safe": `MimaIsSafe_safe__2IHcd`,
	"safe__img": `MimaIsSafe_safe__img__Gv+cj`,
	"safe__text": `MimaIsSafe_safe__text__GkyBs`,
	"safe__text_title": `MimaIsSafe_safe__text_title__0OHQU`,
	"safe__text_body": `MimaIsSafe_safe__text_body__3oU8k`
};
export default ___CSS_LOADER_EXPORT___;
